import * as React from "react";
const SvgBolt = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 13, viewBox: "0 0 10 13", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.4 12.8L3.2 8.4H0L5.4 0H6.6L6 5.2H9.6L3.6 12.8H2.4Z", fill: "white" }));
export default SvgBolt;
